import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Vue3TreeOrg from 'vue3-tree-org';

import '@mdi/font/css/materialdesignicons.css';
import 'vue3-tree-org/lib/vue3-tree-org.css';

// Vuetify
import 'vuetify/styles'
import { aliases, mdi } from 'vuetify/iconsets/mdi'

import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
const vuetify = createVuetify({
    theme: {
        defaultTheme: 'light', // Sets light mode as the default
    },
    components,
    directives,
    icons: {
        defaultSet: 'mdi',
        aliases,
        sets: { mdi },
    },
})

const app = createApp(App)

app.use(router)
app.use(vuetify)
app.use(Vue3TreeOrg)

app.mount('#app')